/* Mobile categories remain readable instead of disappearing in a swipe row. */
(() => {
  const desktop = window.matchMedia('(min-width: 1024px)');
  const init = () => document.querySelectorAll('.ll-treatment-nav').forEach(nav => {
    const chooser = nav.querySelector('.ll-mobile-category');
    const list = nav.querySelector('.ll-treatment-nav__list');
    if (!chooser || !list || nav.dataset.categoryReady) return;
    nav.dataset.categoryReady = 'true';
    const controller = new AbortController();
    const options = { signal: controller.signal };
    const summary = chooser.querySelector('summary');
    const label = chooser.querySelector('[data-category-current]');
    const sync = () => {
      const links = [...list.querySelectorAll('a')];
      const current = links.find(link => link.hasAttribute('aria-current'));
      label.textContent = current?.textContent.trim() || 'Velg kategori';
      chooser.classList.toggle('has-current', Boolean(current));
      summary.setAttribute('aria-label', `${chooser.dataset.categoryLabel}: ${label.textContent}`);
      chooser.querySelectorAll('a').forEach((link, index) => {
        const state = links[index]?.getAttribute('aria-current');
        if (state !== null && state !== undefined) link.setAttribute('aria-current', state);
        else link.removeAttribute('aria-current');
      });
    };
    const close = (restoreFocus = false) => {
      chooser.open = false;
      if (restoreFocus) summary.focus({ preventScroll: true });
    };
    chooser.addEventListener('click', event => {
      if (!(event.target instanceof Element) || !event.target.closest('a')) return;
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      close(true);
    }, options);
    chooser.addEventListener('keydown', event => {
      if (event.key !== 'Escape' || !chooser.open) return;
      event.preventDefault();
      event.stopPropagation();
      close(true);
    }, options);
    chooser.addEventListener('focusout', () => {
      requestAnimationFrame(() => {
        if (!chooser.contains(document.activeElement)) close();
      });
    }, options);
    document.addEventListener('click', event => {
      if (chooser.open && !chooser.contains(event.target)) close();
    }, options);
    window.addEventListener('pageshow', () => { close(); sync(); }, options);
    desktop.addEventListener('change', () => {
      const focused = chooser.contains(document.activeElement);
      close();
      if (desktop.matches && focused) (list.querySelector('[aria-current]') || nav.querySelector('.ll-treatment-nav__overview'))?.focus({ preventScroll: true });
    }, options);
    nav.addEventListener('laserlab:category-current', sync, options);
    document.addEventListener('shopify:section:unload', event => {
      if (!(event.target instanceof Element) || !event.target.contains(nav)) return;
      controller.abort();
      delete nav.dataset.categoryReady;
    }, options);
    sync();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();

/* Skinlab is a category in the current treatment browser, not a new destination. */
(() => {
  const initSkinlab = () => {
    const nav = document.querySelector('.ll-treatment-nav');
    const trigger = nav?.querySelector('[data-skinlab-filter]');
    const original = document.querySelector('[data-treatment-category-view]');
    const skinlab = document.querySelector('[data-skinlab-inline]');
    if (!trigger || !original || !skinlab || nav.dataset.skinlabReady) return;
    nav.dataset.skinlabReady = 'true';
    const originalCurrent = [...nav.querySelectorAll('[aria-current]')].map(link => [link, link.getAttribute('aria-current')]);
    const apply = () => {
      if (!nav.isConnected || !original.isConnected || !skinlab.isConnected) return;
      const selected = window.location.hash === '#skinlab';
      original.hidden = selected;
      skinlab.hidden = !selected;
      nav.querySelectorAll('[aria-current]').forEach(link => link.removeAttribute('aria-current'));
      if (selected) trigger.setAttribute('aria-current', 'true');
      else originalCurrent.forEach(([link, current]) => link.setAttribute('aria-current', current));
      document.querySelectorAll('[data-skinlab-filter]').forEach(link => {
        if (selected) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
      nav.dispatchEvent(new CustomEvent('laserlab:category-current'));
    };
    document.addEventListener('click', event => {
      if (!nav.isConnected || !original.isConnected || !skinlab.isConnected) return;
      if (!(event.target instanceof Element)) return;
      const link = event.target.closest('[data-skinlab-filter], .ll-treatment-nav a');
      if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (link.hasAttribute('download') || (link.target && link.target.toLowerCase() !== '_self')) return;
      const isSkinlab = link.hasAttribute('data-skinlab-filter');
      const destination = new URL(link.href, window.location.href);
      const current = new URL(window.location.href);
      const isOriginal = destination.origin === current.origin && destination.pathname === current.pathname && destination.searchParams.get('view') === current.searchParams.get('view');
      if (!isSkinlab && !(window.location.hash === '#skinlab' && isOriginal)) return;
      event.preventDefault();
      const next = new URL(window.location.href);
      next.hash = isSkinlab ? 'skinlab' : '';
      if (next.href !== window.location.href) window.history.pushState(null, '', next);
      apply();
      if (link.closest('.ll-nav-dropdown, #MenuDrawer')) {
        link.dispatchEvent(new CustomEvent('laserlab:category-selected', { bubbles: true, detail: { heading: skinlab.querySelector('h1') } }));
      }
    });
    window.addEventListener('popstate', apply);
    window.addEventListener('hashchange', apply);
    apply();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSkinlab, { once: true });
  else initSkinlab();
  document.addEventListener('shopify:section:load', initSkinlab);
})();
